module.exports = __webpack_public_path__ + "static/lendsqr-06bfd7792b5c7ba8983216c1c05fcdcc.svg";